import { render, staticRenderFns } from "./PatientCreate.vue?vue&type=template&id=4b10ab5c&scoped=true&"
import script from "./PatientCreate.vue?vue&type=script&lang=js&"
export * from "./PatientCreate.vue?vue&type=script&lang=js&"
import style0 from "./PatientCreate.vue?vue&type=style&index=0&id=4b10ab5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b10ab5c",
  null
  
)

export default component.exports